<template>
	<OrganismFormLead
		:webhook="LeadFormWebhooksEnum.SGT"
		:conversion-value="ConversionValuesEnum.SGT"
		:product-name="LeadFormProductsEnum.SGT"
		form-name="sgt"
		submit-button-text="Small Group Training informatie aanvragen"
		submit-button-icon="fa-bolt"
	/>
</template>

<script lang="ts" setup>
import { LeadFormWebhooksEnum } from '#fit/core/enums/LeadFormWebhooksEnum';
import { ConversionValuesEnum } from '#fit/core/enums/ConversionValuesEnum';
import { LeadFormProductsEnum } from '#fit/core/enums/LeadFormProductsEnum';
</script>
